import styled from 'styled-components';

import { darken } from 'polished';

export const Contactwrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    margin: 80px 0 80px 0;

    figure {
        img{
            width: 600px;
        }
    }

    form {
        h1 {
            font-size: 36px;
            font-weight: 600;
        }

        div {
            display:grid;
            padding: 10px 0px 10px 0px;

            label {
                padding: 10px 10px 10px 0px;
                font-weight: 600;
            }

            input {
                border-radius: 50px;
                width: 300px;
                padding: 10px 10px 10px 15px;
                border: 1px solid var(--white-opacity);
            }

            textarea {
                width: 300px;
                padding: 10px 10px 10px 15px;
                resize: none;
                border: 1px solid var(--white-opacity);
            }
        }

        button {
            background: var(--orange);
            border-radius: 50px;
            border: 0;
            font-weight: 600;
            font-size: 14px;
            padding: 10px 30px 10px 30px;
            color: var(--white);
            transition: 0.3s;

            &:hover {
                background: ${darken(0.1, '#e65a25')}
            }
        }
    }

    @media (max-width: 950px) {

        display: grid;
        align-items: center;
        margin: 80px 0 80px 0;

        figure {
            img{
                display: none;
            }
        }

        form {
            width: 100%;
        h1 {
            font-size: 36px;
            font-weight: 600;
        }

        div {
            display:grid;
            padding: 10px 0px 10px 0px;

            input {
                border-radius: 50px;
                width: 100%;
                padding: 10px 10px 10px 15px;
                border: 1px solid var(--white-opacity);
            }

            label {
                padding: 10px 10px 10px 0px;
                font-weight: 600;
            }

        }
    }
}
`